module.exports = __webpack_public_path__ + "media/components/partials/LandingComponents/General/Footer/img/logo-2902dcc199d3eaa75e21524db1736807.svg";